import React, { FC } from "react";
import Image from "next/image";
import { Trans, useTranslation } from "next-i18next";
import styles from "./OlympiadSteps.module.scss";

import Stage1Img from "@cs/public/img/olympiad/CSO22_Stage1.png";
import Stage2Img from "@cs/public/img/olympiad/CSO22_Stage2.png";
import Stage3Img from "@cs/public/img/olympiad/CSO22_Stage3.png";
import Stage4Img from "@cs/public/img/olympiad/CSO22_Stage4.png";
import { Pill, UnderlineLink } from "@climate-science/component-library";

import { AiOutlineClockCircle } from "react-icons/ai";
import { useRouter } from "next/router";
import { isRTL } from "@cs/lib/getDirFromLocale";

const StepImages = [
  Stage1Img,
  Stage2Img,
  Stage3Img,
  Stage4Img
];

const StepIds = ["1", "2", "3", "4"];

const OlympiadSteps: FC = () => {
  const { t } = useTranslation("olympiad");
  const router = useRouter();

  const LINKS = [
    "https://docs.google.com/document/d/1c6yjFoimfHYpLatvM-MC8JVtExAwsF1kifTBsgWGmoM/edit?usp=sharing",
    "https://docs.google.com/document/d/1QJaIKQEADyNJrMrycmS8mhYjXnbbqyjkOOK6SF_d9XI/edit?usp=sharing",
    "https://docs.google.com/document/d/1AHS-MCm2nUfGzl3e1WcdPcDKHWEk0szdR44MrGC2am8/edit?usp=sharing",
    "#faq-event"
  ];
  return (
    <section className={styles.stepsSection}>
      {
        StepIds.map((stepId, index) => (
          <div className={styles.step} key={index}>
            <div className={styles.stepImage}>
              <Image
                src={StepImages[index]}
                alt={t(`steps.${stepId}.title`)}
              />
            </div>
            <div className={
              isRTL(router.locale) ?
                styles.stepContent_rtl :
                styles.stepContent
            }>
              <h3
                className={styles.stepTitle}>{index + 1}. {t(`steps.${stepId}.title`)}</h3>
              <hr className={styles.titleHr} />
              <p className={styles.stepDate}>
                <AiOutlineClockCircle />
                {t(`steps.${stepId}.date`)}
              </p>
              <div className={styles.stepTags}>
                {t<string, string[]>(`steps.${stepId}.tags`, { returnObjects: true }).map((tag, i) => (
                  <Pill key={i} color="black">{tag}</Pill>
                ))}
              </div>
              <p className={styles.description}>
                <Trans
                  t={t}
                  i18nKey={t(`steps.${stepId}.description`)}
                  components={[
                    <UnderlineLink
                      key={"0"}
                      href={"https://play.google.com/store/apps/details?id=com.climatescience.climate_science"}
                    />,
                    <UnderlineLink
                      key={"1"}
                      href={"https://apps.apple.com/us/app/climatescience-fun-learning/id1490770847"}
                    />
                  ]}
                />
              </p>

              {(t(`steps.${stepId}.learnMore`, {
                returnObjects: true,
                defaultValue: ""
              })) && (
                <>
                  <p className={styles.learnMore}>{t("learn-more")}</p>
                  <ul className={styles.stepLearnMore}>
                    {t<string, { text: string, link: string }[]>(
                      `steps.${stepId}.learnMore`, {
                        returnObjects: true,
                        defaultValue: []
                      }
                    )
                      .map((learnMore, i) => (
                        <li className={styles.stepLearnMoreItem} key={i}>
                          <a
                            href={LINKS[i]}
                            target="_blank"
                            rel="noreferrer"
                          >{learnMore.text}</a>
                        </li>
                      ))}
                  </ul>
                </>
              )}
            </div>
          </div>
        ))
      }
    </section>
  );
};

export default OlympiadSteps;